import { CSSProperties } from 'react';
import { DefaultTheme } from '@mui/styles';
import makeStyles from '@mui/styles/makeStyles';

export const useScrollbarStyles = makeStyles((theme) => ({
  scrollbar: {
    ...getScrollStyles(theme)
  }
}));

export const getScrollStyles = (
  theme: DefaultTheme
): Record<string, CSSProperties | string> => ({
  '&::-webkit-scrollbar': {
    width: theme.spacing(1.25)
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: theme.palette.grey[400],
    borderRadius: theme.spacing(1.25)
  },
  '&::-webkit-scrollbar-thumb:hover': {
    backgroundColor: theme.palette.common.black
  },
  '&::-webkit-scrollbar-track': {
    backgroundColor: 'transparent'
  },
  '&::-webkit-scrollbar-track:hover': {
    backgroundColor: theme.palette.grey[300],
    borderRadius: theme.spacing(1.25)
  },
  'scrollbar-width': 'auto'
});
